import { render } from "./diklat-list.vue?vue&type=template&id=f6c2123a"
import script from "./diklat-list.vue?vue&type=script&lang=js"
export * from "./diklat-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__